import { atom } from 'jotai';

export const groupsAtom = atom([]);
export const accountsAtom = atom([]);
export const initLoadingAtom = atom(true);